import { render } from "./MovementListItem.vue?vue&type=template&id=8b452038&scoped=true&ts=true"
import script from "./MovementListItem.vue?vue&type=script&lang=ts"
export * from "./MovementListItem.vue?vue&type=script&lang=ts"

import "./MovementListItem.vue?vue&type=style&index=0&id=8b452038&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b452038"]])

export default __exports__